import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  booleanAttribute,
  effect,
  inject
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ZefFadeAnimationModule } from 'libs/core/src/animations';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'zef-button-progress',
  templateUrl: './button-progress.component.html',
  styleUrls: [ './button-progress.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressBar,
    ZefFadeAnimationModule
  ]
})
export class ButtonProgressComponent {

  #cdRef = inject(ChangeDetectorRef);

  active = input(false, { transform: booleanAttribute })
  buttonRef = input<MatButton>();
  
  constructor() {
    effect(() => {
      const isActive = this.active();
      if (this.buttonRef()) {
        setTimeout(() => {
          this.buttonRef().disabled = isActive;
          this.#cdRef.markForCheck();
        })
      }
    })
  }

}
